/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Flow_ReviewInputs */

const en_mk_team_flow_review = /** @type {(inputs: Mk_Team_Flow_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03 · Review and approve the phase`)
};

const id_mk_team_flow_review = /** @type {(inputs: Mk_Team_Flow_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03 · Tinjau dan setujui tahap`)
};

/**
* | output |
* | --- |
* | "03 · Review and approve the phase" |
*
* @param {Mk_Team_Flow_ReviewInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_flow_review = /** @type {((inputs?: Mk_Team_Flow_ReviewInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Flow_ReviewInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_flow_review(inputs)
	return en_mk_team_flow_review(inputs)
});